<template>
  <div class="container">
    <div class="row">
      <div class="col-md-3">
        <p class="line-title"><span>Search</span></p>
        <form class="form-search date-range">
          <div class="form-group">
            <label for="keyword">災害類別</label>
            <select
              class="form-control"
              data-style="btn-outline-secondary"
              v-model.trim="search.kind"
            >
              <option value="0">所有類別</option>
              <option
                v-for="(kind, index) in kinds"
                :key="index"
                :value="kind.id"
                >{{ kind.title }}</option
              >
            </select>
          </div>
          <div class="form-group">
            <label for="keyword">關鍵字</label>
            <input
              type="text"
              name="keyword"
              id="keyword"
              class="form-control btn-outline-secondary"
              v-model.trim="search.keyword"
            />
          </div>
          <div class="form-group">
            <label for="startday">時間(起)</label>
            <date-picker
              :config="options"
              class="form-control btn-outline-secondary"
              id="startdate"
              name="startdate"
              maxlength="10"
              placeholder="請選擇日期"
              v-model.trim="search.startdate"
            ></date-picker>
          </div>
          <div class="form-group">
            <label for="endday">時間(迄)</label>
            <date-picker
              :config="options"
              class="form-control btn-outline-secondary"
              id="enddate"
              name="enddate"
              maxlength="10"
              placeholder="請選擇日期"
              v-model.trim="search.enddate"
            ></date-picker>
          </div>
          <button
            type="button"
            class="btn btn-primary btn-block"
            @click="PaginationClick(1)"
          >
            查詢
          </button>
        </form>
      </div>
      <div class="col-md-9">
        <div
          v-if="items.length !== 0"
          class="row masonry-list"
          v-masonry
          transition-duration="0.3s"
          item-selector=".col-md-4"
        >
          <div
            class="col-md-4"
            v-masonry-tile
            v-for="(item, index) in items"
            :key="index"
          >
            <div class="card">
              <router-link :to="'/c-' + item.code"
                ><img
                  :src="item.imgFolder + item.imgName"
                  :alt="item.subject"
                  class="card-img-top img-fluid"
              /></router-link>
              <div class="card-body">
                <p class="h5">
                  <router-link :to="'/c-' + item.code">{{
                    item.subject
                  }}</router-link>
                </p>
                <p class="card-text">
                  <i class="fa fa-calendar" aria-hidden="true"></i>
                  {{ item.occurDate | datestringformat }}
                  <br />
                  <i class="fa fa-location-arrow" aria-hidden="true"></i>
                  {{ item.location }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <nav aria-label="Page navigation" v-if="items.length !== 0">
          <b-pagination
            v-model="search.currentPage"
            :total-rows="total"
            :per-page="perPage"
            :hide-goto-end-buttons="true"
            class="justify-content-center"
            @click.native="PaginationClick(currentPage)"
          ></b-pagination>
        </nav>
        <div class="jumbotron text-center" v-if="items.length === 0">
          <p class="lead">目前沒有資料</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiKind, apiGallery } from '@/api/index'
import datePicker from 'vue-bootstrap-datetimepicker'

export default {
  components: { datePicker },
  data() {
    return {
      kinds: [],
      items: [],
      total: 0,
      perPage: 12,
      search: {
        kind: 0,
        keyword: '',
        startdate: '',
        enddate: '',
        currentPage: 1,
      },
      options: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
      },
    }
  },
  methods: {
    async getList() {
      await apiKind().then(response => {
        this.kinds = response.data
      })
      this.getGallery()
    },
    async getGallery() {
      let loader = this.$loading.show()
      await apiGallery(this.search).then(response => {
        this.items = response.data.items
        this.total = response.data.total
        console.log(this.items)
        setTimeout(() => {
          loader.hide()
        }, 800)
      })
    },
    PaginationClick(currentPage) {
      if (currentPage) {
        this.search.currentPage = currentPage
        this.getGallery()
        this.scrollToTop()
      }
    },
    scrollToTop() {
      let body = window.opera
        ? document.compatMode == 'CSS1Compat'
          ? this.$('html')
          : this.$('body')
        : this.$('html,body')
      body.stop().animate(
        {
          scrollTop: 0,
        },
        800
      )
    },
  },
  mounted() {
    this.getList()
  },
}
</script>
